import "./Sidebar.scss";
import React, { Fragment } from "react";
import { NavLink, useLocation } from "react-router-dom";

import cancelIcon from "../../assets/icons/close.svg";
import logo from "../../assets/logo.png";

const Sidebar = ({ showSidebar, setShowSidebar }) => {
  const location = useLocation();

  return (
    <Fragment>
      <svg
        onClick={() => setShowSidebar(!showSidebar)}
        className="side-icon z-30 items-center cursor-pointer m-2 mr-0 ml-4 xm:w-[20px] xlg:w-[40px] absolute right-3"
        fill={"#252B2B"}
        viewBox="0 0 100 80"
        width="28"
        height="28"
      >
        <rect width="100" height="13"></rect>
        <rect y="30" width="100" height="11"></rect>
        <rect y="60" width="100" height="13"></rect>
      </svg>

      <div
        className={`sidebar-con top-0 right-0 w-[86%] h-screen bg-[#fff] py-[1.5rem] text-red fixed z-40 ${
          showSidebar
            ? "transition duration-1000 ease-in-out translate-x-0"
            : "transition duration-1000 ease-in-out translate-x-full"
        }`}
      >
        <div className="sidebar-header flex justify-between items-center">
          <img className="logo" src={logo} alt="logo" />
          <button
            className="flex text-3xl items-center cursor-pointer z-50"
            onClick={() => setShowSidebar(!showSidebar)}
          >
            <img
              className="w-10 h-10 my-3"
              width={16}
              height={16}
              src={cancelIcon}
              alt="cancelIcon"
            />
          </button>
        </div>
        <ul className="side-menu flex flex-col justify-evenly items-start text-[16px] text-black duration-700 font-bold">
          <NavLink
            onClick={() => setShowSidebar(!showSidebar)}
            className={`flex items-center`}
            to="/"
          >
            <li
              className={`flex items-center ${
                location.pathname === "/" ? "!text-[#C09949]" : ""
              }`}
            >
              خانه
            </li>
          </NavLink>

          <NavLink
            onClick={() => setShowSidebar(!showSidebar)}
            className={`flex items-center`}
            to="/about-us"
          >
            <li
              className={`flex items-center ${
                location.pathname === "/about-us" ? "!text-[#C09949]" : ""
              }`}
            >
              درباره ما
            </li>
          </NavLink>

          <NavLink
            onClick={() => setShowSidebar(!showSidebar)}
            className={`flex items-center`}
            to="/contact-us"
          >
            <li
              className={`flex items-center  ${
                location.pathname === "/contact-us" ? "!text-[#C09949]" : ""
              }`}
            >
              تماس با ما
            </li>
          </NavLink>

          <NavLink
            onClick={() => setShowSidebar(!showSidebar)}
            className={`flex items-center`}
            to="/gallery"
          >
            <li
              className={`flex items-center  ${
                location.pathname === "/gallery" ? "!text-[#C09949]" : ""
              }`}
            >
              گالری
            </li>
          </NavLink>
          <NavLink
            onClick={() => setShowSidebar(!showSidebar)}
            className={`flex items-center`}
            to="/prices"
          >
            <li
              className={`flex items-center  ${
                location.pathname === "/prices" ? "!text-[#C09949]" : ""
              }`}
            >
              نرخ جهانی
            </li>
          </NavLink>
          <NavLink
            onClick={() => setShowSidebar(!showSidebar)}
            className={`flex items-center`}
            to="/archive"
          >
            <li
              className={`flex items-center ${
                location.pathname === "/archive" ? "!text-[#C09949]" : ""
              }`}
            >
              آرشیو
            </li>
          </NavLink>
          <NavLink
            onClick={() => setShowSidebar(!showSidebar)}
            className={`flex items-center`}
            to="/terms-conditions"
          >
            <li
              className={`flex items-center ${
                location.pathname === "/terms-conditions" ? "!text-[#C09949]" : ""
              }`}
            >
              قوانین و مقررات
            </li>
          </NavLink>
        </ul>
      </div>
    </Fragment>
  );
};

export default Sidebar;
